import { QualityCheckFormValues } from '../ProductFormTypes';

export function createEmptyCheck({
  productId,
  checkId = () => Math.floor(Math.random() * 10000000),
}: {
  productId: number;
  checkId?: () => number;
}): QualityCheckFormValues {
  return {
    id: checkId(),
    productId, // set by backend on create
    qualityCheckEnabled: false,
    qualityCheckInstruction: '',
    lastQualityCheckDate: undefined,
    qualityCheckInterval: 'daily',
    qualityCheckName: '',
  };
}
